/** The class that turns on the scoped Nowadays design tokens (see `styles/theme.css`). */
export const NOWADAYS_UI_SCOPE_CLASS = "nw-ui";

/** How many placeholder rows a data table draws while it loads, unless the caller says otherwise. */
export const DATA_TABLE_SKELETON_ROWS = 5;

/**
 * The data table's selection column width in px: room for "Unselect all", the wider of its two
 * labels. Fixed so a pinned first column knows where to stick.
 */
export const DATA_TABLE_SELECTION_COLUMN_WIDTH = 104;

/** The selection column's React Aria key. Not a valid caller column id. */
export const DATA_TABLE_SELECTION_COLUMN_ID = "data-table-selection";

/**
 * Makes the data table's wrapper the box its phone switch measures. A container query, not the
 * viewport, so a table in a narrow sheet or column shows cards too. CSS only, so the server and the
 * first client render agree and no media-query hook is needed.
 */
export const DATA_TABLE_CONTAINER_CLASS = "@container/data-table";

/** Shows the table once its wrapper is at least 640px wide (the kit's `sm` breakpoint). */
export const DATA_TABLE_WIDE_CLASS = "hidden @min-[640px]/data-table:flex";

/** Shows the phone cards while the wrapper is narrower than 640px. */
export const DATA_TABLE_PHONE_CLASS = "@min-[640px]/data-table:hidden";
